var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 17.5V15.7222C14.0001 14.7792 13.6255 13.8749 12.9587 13.2081C12.2919 12.5413 11.3875 12.1667 10.4446 12.1667H5.11122C4.16823 12.1667 3.26386 12.5413 2.59706 13.2081C1.93027 13.8749 1.55566 14.7792 1.55566 15.7222V17.5",
    stroke: "#393838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77821 8.61111C9.74189 8.61111 11.3338 7.01923 11.3338 5.05556C11.3338 3.09188 9.74189 1.5 7.77821 1.5C5.81453 1.5 4.22266 3.09188 4.22266 5.05556C4.22266 7.01923 5.81453 8.61111 7.77821 8.61111Z",
    stroke: "#393838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.71a2d8e692634af4b27ef01553e7070d.svg";
export { ForwardRef as ReactComponent };